import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { EMPTY, Subscription } from 'rxjs';
import { DevicesDevicesService } from 'src/app/services/devices-services/devices-devices-services/devices-devices.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { tap } from 'rxjs/internal/operators/tap';
import { catchError } from 'rxjs/internal/operators/catchError';

@Component({
  selector: 'app-device-list-peripherals-card',
  templateUrl: './device-list-peripherals-card.component.html',
  styleUrls: ['./device-list-peripherals-card.component.scss']
})
export class DeviceListPeripheralsCardComponent implements OnInit {

  @Input() devicePeripherals;
  updateStatusPeripheralSubscription: Subscription;
  deletePeripheralSubscription: Subscription;

  constructor(private router: Router,
              private activatedRoute: ActivatedRoute,
              private devicesDevicesService: DevicesDevicesService,
              private snackbarService: SnackBarService) { }

  ngOnInit() {
  }

  public newPeripheral() {
    this.router.navigate(['peripheral'], {relativeTo: this.activatedRoute});
  }

  public editPeripheral(peripheral) {
    this.router.navigate(['peripheral/', peripheral.InternalId], {relativeTo: this.activatedRoute});
  }

  public updateStatusPeripheral(peripheral) {
    this.updateStatusPeripheralSubscription = this.devicesDevicesService.updateStatusPeripheral(peripheral.InternalId).pipe(
      tap(o => this.devicesDevicesService.refreshDevice()),
      catchError(error => {
        this.snackbarService.open(error['error']['message'], 'error');
        return EMPTY;
      })
    ).subscribe();
  }

  public deletePeripheral(peripheral) {
    this.deletePeripheralSubscription = this.devicesDevicesService.deletePeripheral(peripheral.InternalId).pipe(
      tap(o => this.devicesDevicesService.refreshDevice()),
      catchError(error => {this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

}
